// extracted by mini-css-extract-plugin
export default {"wrapperMobile":"fail-module__wrapperMobile__xXYLY","description":"fail-module__description__jS0lh"};